<template>

  <div class="elevation-4">
    <v-toolbar flat="flat">
      <v-toolbar-title>Sport Order</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-3" disabled="disabled">{{sportOrder}}</v-btn>
    </v-toolbar>
  </div>

</template>

<script>

export default {
  name: 'SportOrder',
  props: ['id', 'loading'],
  computed: {
    sportOrder () {
      const sport = this.$store.state.sports[this.id]
      if (sport === undefined) {
        return []
      }
      console.log(sport.sportOrder)
      return sport.sportOrder
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/sport/SportOrder.vue